"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenWebModel = void 0;
const JwtCheckService_1 = require("../Service/AuthToken/JwtCheckService");
const AbstractTokenModel_1 = require("./AbstractTokenModel");
class TokenWebModel extends AbstractTokenModel_1.AbstractTokenModel {
    validateRefreshToken(publicKey) {
        return this.checkToken(this.refreshToken, publicKey ?? this.defaultPublicKey);
    }
    validateToken(publicKey) {
        return this.checkToken(this.token, publicKey ?? this.defaultPublicKey);
    }
    parseToken(token) {
        return JwtCheckService_1.JwtCheckService.decode(token);
    }
    checkToken(token, key) {
        return JwtCheckService_1.JwtCheckService.verify(token, key);
    }
}
exports.TokenWebModel = TokenWebModel;
//# sourceMappingURL=TokenWebModel.js.map